// src/components/UI/components/DropdownMenu/DropdownMenuItem.tsx

import { Item } from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { cx } from '../../lib/utils';

const DropdownMenuItem = forwardRef<
  React.ElementRef<typeof Item>,
  React.ComponentPropsWithoutRef<typeof Item> & {
    shortcut?: string;
    hint?: string;
  }
>(({ className, shortcut, hint, children, ...props }, forwardedRef) => (
  <Item
    ref={forwardedRef}
    className={cx(
      // base
      'group/DropdownMenuItem relative flex cursor-pointer select-none items-center rounded py-2 pl-4 pr-2 outline-none transition-colors font-accent sm:text-sm',
      // text color
      'text-revving-content dark:text-darkRevving-content',
      // disabled
      'data-[disabled]:pointer-events-none data-[disabled]:text-gray-400 data-[disabled]:hover:bg-none dark:data-[disabled]:text-gray-600',
      // focus
      'focus-visible:text-revving-content-strong focus-visible:bg-revving-brand-faint focus-visible:dark:text-darkRevving-content-strong focus-visible:dark:bg-darkRevving-brand-faint',
      // hover
      'hover:text-revving-content-strong hover:bg-revving-brand-faint hover:dark:text-darkRevving-content-strong hover:dark:bg-darkRevving-brand-faint',
      className,
    )}
    tremor-id="tremor-raw"
    {...props}
  >
    {children}
    {hint && (
      <span
        className={cx('ml-auto pl-2 text-sm text-gray-400 dark:text-gray-600')}
      >
        {hint}
      </span>
    )}
    {shortcut && (
      <span
        className={cx('ml-auto pl-2 text-sm text-gray-400 dark:text-gray-600')}
      >
        {shortcut}
      </span>
    )}
  </Item>
));
DropdownMenuItem.displayName = 'DropdownMenuItem';

export { DropdownMenuItem };
